<template>
  <base-dropdown :position="position" :close-by-menu-click="true">
    <template #buttonText>
      <template v-if="title">
        {{ title }}
      </template>
      <template v-else>
        {{ selectedTitle }}
      </template>
    </template>
    <template #dropdownContent>
      <div
        v-for="(option, id) in options"
        :key="id"
        :data-value="id"
        class="dropdown-item"
        :class="[option.color ? `text-${option.color}` : '', { active: id == selected }]"
        @click="selectValue"
      >
        {{ option.title ? option.title : option }}
      </div>
    </template>
  </base-dropdown>
</template>

<script>
import BaseDropdown from '@/base/BaseDropdown.vue'

export default {
  name: 'BaseDropdownSelect',
  components: {
    BaseDropdown: BaseDropdown
  },
  model: {
    prop: 'selected'
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    selected: {
      type: [String, Number],
      required: false
    },
    title: {
      type: String
    },
    position: {
      type: String,
      required: false,
      default: 'down'
    }
  },
  data: () => ({
    localSelected: null
  }),
  watch: {
    selected() {
      this.localSelected = this.selected
    }
  },
  computed: {
    selectedTitle() {
      if (!this.localSelected) {
        return '-'
      }
      if (!this.options[+this.localSelected]) {
        return this.options[Object.keys(this.options)[0]].title
          ? this.options[Object.keys(this.options)[0]].title
          : this.options[Object.keys(this.options)[0]]
      }
      return this.options[this.localSelected].title
        ? this.options[this.localSelected].title
        : this.options[this.localSelected]
    }
  },
  mounted() {
    if (this.selected) {
      this.localSelected = this.selected
    }
  },
  methods: {
    selectValue(e) {
      this.localSelected = e.target.dataset.value
      this.$emit('input', this.localSelected)
    }
  }
}
</script>
